import { IPagination } from "./api";

export interface IResponseListCustomersSuppliers extends IPagination {
    customersSuppliers: ICustomersSuppliers[];
}

export interface IResponseShowCustomerSupplier {
    customerSupplier: ICustomersSuppliers;
    origin?: ICustomerSupplierOrigin;
}

/** Desfecho da sincronização do cliente/fornecedor ao salvar uma terceirizada ou um cliente. */
export enum ECustomerSupplierLinkResult {
    Created = "created",
    AlreadyExisted = "alreadyExisted",
    ChangedToBoth = "changedToBoth",
}

/** Código do erro 409 quando o documento já existe com nome, e-mail ou endereço diferentes. */
export const CUSTOMER_SUPPLIER_CONFLICT = "CUSTOMER_SUPPLIER_CONFLICT";

/** Cadastro que já usa o documento e os dados dele que podem ser copiados. */
export interface ICustomerSupplierConflict {
    source: "outsourced" | "customer" | "customerSupplier";
    name: string;
    data: { name?: string; email?: string; address?: string; phone?: string };
}

/** Terceirizada e cliente que têm o mesmo documento do cliente/fornecedor. */
export interface ICustomerSupplierOrigin {
    outsourced?: { id: number; name: string };
    customer?: { id: number; name: string };
}

export interface ICustomersSuppliers {
    id: number;
    name: string;
    email?: string;
    phone?: string;
    type: 'customer' | 'supplier' | 'both';
    address?: string;
    document?: string;
    createdIn?: Date;
    updatedIn?: Date;
    createdBy?: string;
    updatedBy?: string;
}
